import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const BackButton = styled.a`
  cursor: pointer;
  font-size: 16px;
  left: 5%;
  position: absolute;
  top: 100px;
`;

const Container = styled.div`
  margin-bottom: 40px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 100px;
  max-width: 700px;
`;

const Instruction = styled(TextLayoutComponent)`
  margin-bottom: 15px;
`;

export {
  BackButton,
  Container,
  Instruction,
};
